import { AgGridModule } from '@ag-grid-community/angular';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DynamicTableModule } from '@frk/eds-components';
import { SharedModule } from '@shared/shared.module';
import { HighchartsChartModule } from 'highcharts-angular';
import { ManagerRosterComponent } from './manager-roster/manager-roster.component';
import { PortfolioChartsComponent } from './portfolio-charts/portfolio-charts.component';
import { PortfolioEntryComponent } from './portfolio-entry/portfolio-entry.component';
import { PortfolioHoldingsComponent } from './portfolio-holdings/portfolio-holdings.component';
import { PortfolioService } from './services/portfolio.service';
import { BenchmarkTableComponent } from './statistics-and-positions/benchmark-table/benchmark-table.component';
import { StatisticsAndPositionsComponent } from './statistics-and-positions/statistics-and-positions.component';
import { HistoricWeightedAverageTableComponent } from './statistics-and-positions/historic-weighted-average-table/historic-weighted-average-table.component';

/**
 * Module for Portfolio components
 */
@NgModule({
  imports: [
    AgGridModule,
    CommonModule,
    DynamicTableModule,
    FormsModule,
    HighchartsChartModule,
    RouterModule,
    SharedModule,
  ],
  declarations: [
    BenchmarkTableComponent,
    ManagerRosterComponent,
    PortfolioChartsComponent,
    PortfolioEntryComponent,
    PortfolioHoldingsComponent,
    StatisticsAndPositionsComponent,
    HistoricWeightedAverageTableComponent,
  ],
  entryComponents: [PortfolioEntryComponent, StatisticsAndPositionsComponent],
  providers: [PortfolioService],
})
export class PortfolioModule {
  constructor() {
    ModuleRegistry.registerModules([ClientSideRowModelModule]);
  }
}

export const portfolioModuleComponentMapping = {
  'Fund Portfolio': PortfolioEntryComponent,
  'Manager Roster / Allocation': PortfolioEntryComponent,
};
